import React from "react";
import { iconProps } from "../../../Helper";

export const TranslatorIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_8637_86009"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8637_86009)">
        <path
          className={className}
          d="M7.9331 14.3335L10.9023 6.66684H11.9433L14.9126 14.3335H13.8523L13.0973 12.3002H9.74843L8.99326 14.3335H7.9331ZM2.67276 12.372L1.97026 11.6693L5.2856 8.34767C4.90104 7.95878 4.53549 7.49723 4.18893 6.96301C3.84226 6.42878 3.55699 5.88562 3.3331 5.33351H4.39326C4.5856 5.73695 4.8196 6.14039 5.09526 6.54384C5.37093 6.94717 5.6686 7.31423 5.98826 7.64501C6.46171 7.16723 6.90954 6.58712 7.33176 5.90467C7.75399 5.22223 8.05232 4.58739 8.22676 4.00017H1.12793V3.00017H5.49976V1.92334H6.49976V3.00017H10.8716V4.00017H9.23943C9.02321 4.74884 8.6786 5.53151 8.2056 6.34817C7.73249 7.16484 7.22754 7.83817 6.69076 8.36817L8.3356 10.0527L7.95743 11.0797L5.98826 9.06034L2.67276 12.372ZM10.0689 11.4155H12.7766L11.4228 7.77834L10.0689 11.4155Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
